import React from "react";
import { TableRow } from "Table/interfaces";
import { StyledTable, StyledTableContent } from "../style";
import RowElement from "./RowElement";

interface Props {
    data: any;
    fixed?: boolean;
    rowHeights?: number[];
    columnWidths?: number[];
}

const TableSection: React.FC<Props> = ({ data, rowHeights, fixed, columnWidths }) => (
    <StyledTable cellSpacing="0">
        <StyledTableContent>
            {data.map((row: TableRow, i: number) => (
                <RowElement
                    key={i}
                    height={rowHeights ? rowHeights[i + 1] : undefined}
                    fixed={fixed}
                    rowIndex={i + 1}
                    row={row}
                    columnWidths={columnWidths}
                />
            ))}
        </StyledTableContent>
    </StyledTable>
);

const MemoizedComponent = React.memo(TableSection);
export default MemoizedComponent;
